import React from 'react';
import { Modal, Input, Select, Spin } from 'antd';
import styles from './AddMessageModal.module.scss';
import { useSelector } from 'react-redux';
import { CUSTOMER } from '../../../api/Constants';
import AttachmentPreviewList from "../AttachmentPreviewList/AttachmentPreviewList";

const AddMessageModal = ({
    title,
    isModalOpen,
    handleOk,
    handleCancel,
    clearFields,
    addTitle,
    addMessage,
    setAddTitle,
    setAddMessage,
    setMessageFor,
    messageFor,
    attachments = [],
    onSelectFiles,
    onRemoveAttachment,
    isUploading = false,
    isSubmitting = false,
}) => {

    const websiteUsers = useSelector(state => state?.allWebsiteUsers?.website_users);
    const props = useSelector((state) => state)
    const loggedInUser = props.auth?.loggedInUser;

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files || []);
        if (!files.length || !onSelectFiles) {
            return;
        }
        onSelectFiles(files);
        event.target.value = null;
    };

    return (
        <Modal 
            title={title}
            open={isModalOpen.status === 'Re-open' ? isModalOpen.open : isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            afterClose={() => clearFields()}
            okButtonProps={{ 
                disabled: !(addTitle && addMessage) || isUploading || isSubmitting,
                loading: isSubmitting,
            }}
            cancelButtonProps={{ disabled: isSubmitting }}
            maskClosable={!isSubmitting}
        >
            <Spin spinning={isSubmitting} tip="Creating message...">
                <Input 
                    className={styles.addTitleField} 
                    disabled={isModalOpen.status === 'Re-open' || isSubmitting} 
                    value={addTitle} 
                    onChange={e => setAddTitle(e.target.value)} 
                    placeholder="Add Title" 
                />
                <Input 
                    className={styles.addMessageField} 
                    disabled={isSubmitting}
                    value={addMessage} 
                    onChange={e => setAddMessage(e.target.value)} 
                    placeholder="Add Message" 
                />
            <div className={styles.uploadWrapper}>
                <label className={styles.uploadLabel}>
                    <span>Select images / videos</span>
                    <input
                        type="file"
                        accept="image/*,video/*"
                        multiple
                        className={styles.fileInput}
                        onChange={handleFileChange}
                    />
                </label>
                <AttachmentPreviewList
                    items={attachments}
                    onRemove={onRemoveAttachment}
                />
            </div>
            {loggedInUser?.client_type !== CUSTOMER &&
            <Select
                className={styles.selectUsersList}
                showSearch
                disabled={isSubmitting}
                optionFilterProp="children"
                filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? '').includes(input.toLowerCase())}
                options={
                    websiteUsers
                        ? websiteUsers
                            .filter(user => user.client_type === CUSTOMER)
                            .map(user => ({ value: user.client_id, label: user.fullname }))
                        : []
                }
                value={messageFor}
                onChange={(value) => setMessageFor(value)}
                placeholder="Message For Customer"
            />
        }
            </Spin>
        </Modal>
    );
};

export default AddMessageModal;
